module.exports = __webpack_public_path__ + "SCGumKids.woff?cc1626a13c6f8519e6cc6fc609f50c5b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SCGumKids.woff
// module id = 5
// module chunks = 0